"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Breadcrumbs = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var button_1 = require("../button");
var classnames_1 = require("../util/classnames");
var vdl_prefix_1 = require("../util/vdl-prefix");
var angle_right_1 = __importDefault(require("adp-react-icons/lib/fa/angle-right"));
var Breadcrumbs = function Breadcrumbs(props) {
  var _a;
  var onBreadcrumbClick = function onBreadcrumbClick(crumb) {
    if (props.onBreadcrumbsViewItem) {
      props.onBreadcrumbsViewItem(crumb);
    }
  };
  var renderBreadcrumbs = function renderBreadcrumbs() {
    var _a;
    var itemsLength = props.historyItems.length;
    var activeBreadcrumbclasses = classnames_1.classNames((_a = {}, _a[vdl_prefix_1.vdlPrefix('breadcrumbs__item--active')] = true, _a[vdl_prefix_1.vdlPrefix('breadcrumbs__item--active-alternative')] = props.type === 'traditional', _a));
    return props.historyItems.map(function (item, idx) {
      var isLast = idx === itemsLength - 1;
      return react_1.default.createElement("li", {
        key: item.key || idx,
        "aria-current": isLast,
        className: vdl_prefix_1.vdlPrefix('breadcrumbs__item') + " " + (isLast ? activeBreadcrumbclasses : '')
      }, !isLast ? react_1.default.createElement("span", {
        className: "center-content"
      }, react_1.default.createElement(button_1.Button, {
        id: "" + vdl_prefix_1.vdlPrefix("breadcrumb" + idx),
        className: props.type,
        buttonStyle: "link",
        onClick: function onClick() {
          return onBreadcrumbClick(item);
        }
      }, item.iconType ? item.iconType : '', !(props.displayIconsOnly || item.iconOnly) ? react_1.default.createElement("span", {
        className: "" + vdl_prefix_1.vdlPrefix('breadcrumb__text')
      }, item.text) : ''), props.type === 'traditional' ? react_1.default.createElement("span", {
        className: "" + vdl_prefix_1.vdlPrefix('breadcrumbs__delimiter')
      }, react_1.default.createElement(angle_right_1.default, null)) : react_1.default.createElement("span", {
        className: "" + vdl_prefix_1.vdlPrefix('breadcrumbs__delimiter')
      }, "/")) : react_1.default.createElement("span", {
        className: "center-content"
      }, item.iconType ? item.iconType : '', !(props.displayIconsOnly || item.iconOnly) ? react_1.default.createElement("span", {
        className: "" + vdl_prefix_1.vdlPrefix('breadcrumb__text')
      }, item.text) : ''));
    });
  };
  var containerClasses = classnames_1.classNames((_a = {}, _a[vdl_prefix_1.vdlPrefix('breadcrumbs')] = true, _a[vdl_prefix_1.vdlPrefix('breadcrumbs--background')] = props.displayBackground, _a));
  return react_1.default.createElement("ul", {
    className: containerClasses,
    role: "navigation",
    "aria-label": "breadcrumbs"
  }, props.historyItems && props.historyItems.length ? renderBreadcrumbs() : null);
};
exports.Breadcrumbs = Breadcrumbs;
exports.Breadcrumbs.propTypes = {
  historyItems: prop_types_1.default.array,
  displayBackground: prop_types_1.default.bool,
  displayIconsOnly: prop_types_1.default.bool,
  type: prop_types_1.default.oneOf(['default', 'traditional'])
};
exports.Breadcrumbs.defaultProps = {
  displayBackground: true,
  displayIconsOnly: false,
  type: 'default'
};
exports.Breadcrumbs.displayName = 'Breadcrumbs';